import React, { useContext, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DirectionalHint, Icon } from '@fluentui/react';
import '../style.css';
import { useSelector } from 'react-redux';
import MainAppContext from '../../../MainAppContext';
import { enum__AppElementType, enum_ENUM_dIcono_Revision, enum_ENUM_FLUJO_EP, enum_ENUM_ICONO_REVISION, enum_ENUM_TIPO_RESPUESTA } from '../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmptyOrNegative } from '../../../common/Helpers';
import PropTypes from 'prop-types';
import ApprovePartieDiPanel from './ApprovePartieDiPanel';
import { __GetClientRoleCode } from '../../../common/CommonFuctions';

const AprobacionFlujoEdP = (props) => {
    const contextSite = useContext(MainAppContext);

    const {
        _edpPrepareHeader: edpPrepareHeader,
    } = useSelector((state) => state.edpPreparationState);

    const { 
        inputParam_ElementId = null,
        inputParam_EdPId = null,
    } = props;

    const _priv_canEditEdP = (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) && !contextSite.onlyObserver;

    const [calloutVisibleIndex, setCalloutVisibleIndex] = useState(null);
    const [isAprovePanelOpen, setIsAprovePanelOpen] = useState(false);

    const onOpenAprovePanel = (_tipo_aprobacion_rfa_adn) => {
        setCalloutVisibleIndex(_tipo_aprobacion_rfa_adn);
        setIsAprovePanelOpen(true);

    }

    //(calloutVisibleIndex.indexOf('rfa_') !== -1 ? (edpPrepareHeader.icono_tipo_rfa1 !== 'div' || edpPrepareHeader.icono_tipo_rfa2 !== 'div' || edpPrepareHeader.icono_tipo_rfa3 !== 'div') : false)
    const getRFAButtonByEtapaFlujo = (etapa_flujo_id) => {
        let result = false;

        switch (calloutVisibleIndex) {
            case  'rfa_' + enum_ENUM_TIPO_RESPUESTA.RFA1:
                result = etapa_flujo_id === enum_ENUM_FLUJO_EP.ABROPACION_RFA1;
                break;
            case 'rfa_' + enum_ENUM_TIPO_RESPUESTA.RFA2:
                result = etapa_flujo_id === enum_ENUM_FLUJO_EP.ABROPACION_RFA2;
                break;
            case 'rfa_' + enum_ENUM_TIPO_RESPUESTA.RFA3:
                result = etapa_flujo_id === enum_ENUM_FLUJO_EP.ABROPACION_RFA3;
                break;
            default:
                break;
        }

        return result
    }

    const getIconoRevision = (icono, tipo_aprobacion_rfa_adn) => {
        let global_deshabilitar_boton = true;
        console.log();
        let global_control = null;
        console.log();
        if (tipo_aprobacion_rfa_adn === `adn_${enum_ENUM_TIPO_RESPUESTA.ADN}`) {
            console.log();
            global_deshabilitar_boton = edpPrepareHeader.icono_tipo_adn === "div";
            console.log();
            
            if (enum_ENUM_ICONO_REVISION.NINGUNO !== icono || _priv_canEditEdP) {
                console.log();
                global_control = global_deshabilitar_boton && !_priv_canEditEdP
                ?   <div   type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`}  />
                :   <input type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${_priv_canEditEdP && icono === enum_ENUM_ICONO_REVISION.NINGUNO ? enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.SIN_REVISAR).value : enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`} onClick={ () => onOpenAprovePanel(tipo_aprobacion_rfa_adn) } />
            }
            else {
                console.log();
                global_control = <></>
            }
        }
        else if (tipo_aprobacion_rfa_adn === `rfa_${enum_ENUM_TIPO_RESPUESTA.RFA1}`) {
            console.log();
            if (edpPrepareHeader.icono_aprobacion_rfa1 != enum_ENUM_ICONO_REVISION.NINGUNO)
            {
                console.log();
                if (edpPrepareHeader.icono_aprobacion_adn == enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO ||
                    edpPrepareHeader.icono_aprobacion_adn == enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO_REVISAR ||
                    edpPrepareHeader.icono_aprobacion_adn == enum_ENUM_ICONO_REVISION.DESHABILITADO_RECHAZADO ||
                    edpPrepareHeader.icono_aprobacion_adn == enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR)
                {
                    console.log();
                    global_deshabilitar_boton = edpPrepareHeader.icono_tipo_rfa1 === "div";

                    console.log();
                    if (enum_ENUM_ICONO_REVISION.NINGUNO !== icono || _priv_canEditEdP) {
                        console.log();
                        global_control = global_deshabilitar_boton && !_priv_canEditEdP
                        ?   <div   type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`}  />
                        :   <input type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${_priv_canEditEdP && icono === enum_ENUM_ICONO_REVISION.NINGUNO ? enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.SIN_REVISAR).value : enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`} onClick={ () => onOpenAprovePanel(tipo_aprobacion_rfa_adn) } />
                    }
                    else {
                        console.log();
                        global_control = <></>
                    }
                }
                else
                {
                    console.log();
                    global_control = <div type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR).value}`}  />
                }
            }
            else {
                console.log();
                global_control = <></>
            }
        }
        else if (tipo_aprobacion_rfa_adn === `rfa_${enum_ENUM_TIPO_RESPUESTA.RFA2}`) {
            console.log();
            if (edpPrepareHeader.icono_aprobacion_rfa2 != enum_ENUM_ICONO_REVISION.NINGUNO)
            {
                console.log();
                if (edpPrepareHeader.icono_aprobacion_rfa1 == enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO)
                {
                    console.log();
                    global_deshabilitar_boton = edpPrepareHeader.icono_tipo_rfa2 === "div";
                    console.log();

                    if (enum_ENUM_ICONO_REVISION.NINGUNO !== icono || _priv_canEditEdP) {
                        console.log();
                        global_control = global_deshabilitar_boton && !_priv_canEditEdP
                        ?   <div   type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`}  />
                        :   <input type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${_priv_canEditEdP && icono === enum_ENUM_ICONO_REVISION.NINGUNO ? enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.SIN_REVISAR).value : enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`} onClick={ () => onOpenAprovePanel(tipo_aprobacion_rfa_adn) } />
                    }
                    else {
                        console.log();
                        global_control = <></>
                    }
                }
                else
                {
                    console.log();
                    global_control = <div type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR).value}`}  />
                }
            }
            else {
                console.log();
                global_control = <></>
            }
        }
        else if (tipo_aprobacion_rfa_adn === `rfa_${enum_ENUM_TIPO_RESPUESTA.RFA3}`) {
            console.log();
            if (edpPrepareHeader.icono_aprobacion_rfa3 != enum_ENUM_ICONO_REVISION.NINGUNO)
            {
                console.log();
                if (edpPrepareHeader.icono_aprobacion_rfa2 == enum_ENUM_ICONO_REVISION.DESHABILITADO_APROBADO)
                {
                    console.log();
                    global_deshabilitar_boton = edpPrepareHeader.icono_tipo_rfa3 === "div";

                    console.log();
                    if (enum_ENUM_ICONO_REVISION.NINGUNO !== icono || _priv_canEditEdP) {
                        console.log();
                        global_control = global_deshabilitar_boton && !_priv_canEditEdP
                        ?   <div   type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`}  />
                        :   <input type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${_priv_canEditEdP && icono === enum_ENUM_ICONO_REVISION.NINGUNO ? enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.SIN_REVISAR).value : enum_ENUM_dIcono_Revision.find(x => x.key === icono).value}`} onClick={ () => onOpenAprovePanel(tipo_aprobacion_rfa_adn) } />
                    }
                    else {
                        console.log();
                        global_control = <></>
                    }
                }
                else
                {
                    console.log();
                    global_control = <div type='button' id={`${`revision_${tipo_aprobacion_rfa_adn}`}`} className={`mt-1 mx-1 button-estados ${enum_ENUM_dIcono_Revision.find(x => x.key === enum_ENUM_ICONO_REVISION.DESHABILITADO_SIN_REVISAR).value}`}  />
                }
            }
            else {
                console.log();
                global_control = <></>
            }
        }

        return  !isNullUndefinedOrEmptyOrNegative(icono) ?
        <>
            {   global_control   }
        </> : <></>
    }

    return (
        <Row className='text-center tablaAprobacion'>
            <Col className='titAprobacion my-auto'>Aprobación</Col>
            <Col className='col-aprobacion'>
                <Row><Col>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'ADN')}</Col></Row>
                <Row>
                    <Col>
                        {
                            getIconoRevision(edpPrepareHeader.icono_aprobacion_adn, `adn_${enum_ENUM_TIPO_RESPUESTA.ADN}`, 'ADN')
                        }
                    </Col>
                </Row>
            </Col>
            <Col className='my-auto p-0'><Icon iconName='ChevronRightSmall' /></Col>
            <Col className='col-aprobacion'>
                <Row><Col>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'RFA')} 1</Col></Row>
                <Row>
                    <Col>
                        {
                            edpPrepareHeader.cantidad_rfa >= 1 && getIconoRevision(edpPrepareHeader.icono_aprobacion_rfa1, `rfa_${enum_ENUM_TIPO_RESPUESTA.RFA1}`, 'RFA1')
                        }
                    </Col>
                </Row>
            </Col>
            <Col className='my-auto p-0'><Icon iconName='ChevronRightSmall' /></Col>
            <Col className='col-aprobacion'>
                <Row><Col>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'RFA')} 2</Col></Row>
                <Row>
                    <Col>
                        { 
                            edpPrepareHeader.cantidad_rfa >= 2 && getIconoRevision(edpPrepareHeader.icono_aprobacion_rfa2, `rfa_${enum_ENUM_TIPO_RESPUESTA.RFA2}`, 'RFA2')
                        }
                    </Col>
                </Row>
            </Col>
            <Col className='my-auto p-0'><Icon iconName='ChevronRightSmall' /></Col>
            <Col className='col-aprobacion'>
                <Row><Col>{__GetClientRoleCode(contextSite.applicationRoles, enum__AppElementType.CONTRACT, 'RFA')} 3</Col></Row>
                <Row>
                    <Col>
                        {
                            edpPrepareHeader.cantidad_rfa >= 3 && getIconoRevision(edpPrepareHeader.icono_aprobacion_rfa3, `rfa_${enum_ENUM_TIPO_RESPUESTA.RFA3}`, 'RFA3')
                        }
                    </Col>
                </Row>
            </Col>
            {
                calloutVisibleIndex && isAprovePanelOpen === true &&
                <ApprovePartieDiPanel
                    inputParam_ElementId={inputParam_ElementId}
                    inputParam_EdPId={inputParam_EdPId}
                    inputParam_DialogTitleText={''}
                    inputParam_TargetControlId={`#${`revision_${calloutVisibleIndex}`}`}
                    inputParam_IsPanelOpen={isAprovePanelOpen}
                    inputParam_SetterIsPanelOpen={setIsAprovePanelOpen}
                    inputParam_VerRevision={edpPrepareHeader.verRevision}
                    inputParam_RolTipoRespuestaId={edpPrepareHeader.rolTipoRespuestaRevision}
                    inputParam_RolMatrizEtapaFlujo={edpPrepareHeader.rolMatrizEtapaFlujo}
                    inputParam_EstadoPagoPartidaId={null}
                    inputParam_PartidaId={null}
                    inputParam_EstadoPagoCompuestaDiId={null}
                    inputParam_Iteracion={edpPrepareHeader.iteracioN_EP}
                    inputParam_DisplayDirection={DirectionalHint.leftBottomEdge}
                    inputParam_RefreshPage={true}
                    inputParam_EditMode={
                        edpPrepareHeader.etapA_FLUJO_ID !== enum_ENUM_FLUJO_EP.HISTORICO && edpPrepareHeader.etapA_FLUJO_ID !== enum_ENUM_FLUJO_EP.APROBADO && edpPrepareHeader.etapA_FLUJO_ID !== enum_ENUM_FLUJO_EP.ANULADO ? 
                        calloutVisibleIndex.indexOf('adn_') !== -1 ? (edpPrepareHeader.icono_tipo_adn !== 'div' && edpPrepareHeader.icono_aprobacion_adn !== 3 && edpPrepareHeader.icono_aprobacion_adn !== 4 && edpPrepareHeader.icono_aprobacion_adn !== 5) : (calloutVisibleIndex.indexOf('rfa_') !== -1 ? (getRFAButtonByEtapaFlujo(edpPrepareHeader.etapA_FLUJO_ID)) : false)
                        : false
                    }
                    inputParam_EdpIatrizEtapaId={
                        calloutVisibleIndex.indexOf('adn_') !== -1 ?
                            (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'aprobacion')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'aprobacion').id : 0)
                            :
                            (calloutVisibleIndex.indexOf(`rfa_${enum_ENUM_TIPO_RESPUESTA.RFA1}`) !== -1 ?
                                (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa1')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa1').id : 0)
                                :
                                (calloutVisibleIndex.indexOf(`rfa_${enum_ENUM_TIPO_RESPUESTA.RFA2}`) !== -1 ?
                                (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa2')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa2').id : 0)
                                :
                                (calloutVisibleIndex.indexOf(`rfa_${enum_ENUM_TIPO_RESPUESTA.RFA3}`) !== -1 ?
                                (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa3')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa3').id : 0)
                                :
                                '')))
                    }
                    inputParam_TipoRespuestaId={
                        calloutVisibleIndex.indexOf('adn_') !== -1 ?
                            (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'aprobacion')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'aprobacion').tipo_respuesta_id : 0)
                            :
                            (calloutVisibleIndex.indexOf(`rfa_${enum_ENUM_TIPO_RESPUESTA.RFA1}`) !== -1 ?
                                (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa1')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa1').tipo_respuesta_id : 0)
                                :
                                (calloutVisibleIndex.indexOf(`rfa_${enum_ENUM_TIPO_RESPUESTA.RFA2}`) !== -1 ?
                                (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa2')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa2').tipo_respuesta_id : 0)
                                :
                                (calloutVisibleIndex.indexOf(`rfa_${enum_ENUM_TIPO_RESPUESTA.RFA3}`) !== -1 ?
                                (!isNullUndefined(edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa3')) ? edpPrepareHeader.l_etapas_revision.find(x => x.sector === 'rfa3').tipo_respuesta_id : 0)
                                :
                                '')))
                    }
                />
            }
        </Row>
    );
};

AprobacionFlujoEdP.propTypes = {
    inputParam_ElementId: PropTypes.number,
    inputParam_EdPId: PropTypes.number,
};

export default AprobacionFlujoEdP;